module.exports = __webpack_public_path__ + "static/img/title_3.7375188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/title_3.png
// module id = fIXI
// module chunks = 1